import React, { Component } from "react";
import "./InsertPhone.css";
import Button from "../components/Button";
import Title from "../components/Title";
import PhoneInput from "../components/PhoneInput";
import EmailInput from "../components/EmailInput";
import CPFInput from "../components/CPF";

class InsertPhone extends Component {
	constructor(props) {
		super(props);
		this.initialState = {
			firstBlur: true,
		};
		this.state = this.initialState;
	}

	handleClick = () => {
		this.props.sendFoneHandler();
	};

	handleClickTerms = (state) => {
		this.props.callTerms(true);
	};

	onChangeHandler = (e) => {
		const val = this.phoneInput.value();

		if (val.length >= 16) {
			this.button.buttonElement.focus();
		}
		this.props.onChange(val, "phone");
	};

	onChangeHandlerCPF = (e) => {
		const val = this.CPFInput.value();

		if (val.length >= 16) {
			this.button.buttonElement.focus();
		}
		this.props.onChange(val, "cpf");
	};

	onChangeHandlerEmail = (e) => {
		var val = this.emailInput.value();
		val = val.substr(0, 64);

		/*
    if(val.includes('@') && val.includes('.com')) {
      this.button.buttonElement.focus()
    }*/
		this.props.onChange(val, "email");
	};

	onBlurHandler = (e) => {
		if (this.state.firstBlur) {
			let newState = {};
			newState.firstBlur = false;
			this.setState(() => newState);
		}
	};

	fieldEmail = (e) => {
		if (e === true) {
			const { email } = this.props;
			return (
				<div className="ha-v">
					<EmailInput
						ref={(input) => {
							this.emailInput = input;
						}}
						onChange={this.onChangeHandlerEmail}
						value={email}
					/>
				</div>
			);
		}
	};

	fieldCPF = (e) => {
		if (e === true) {
			const { cpf } = this.props;
			return (
				<CPFInput
					ref={(input) => {
						this.CPFInput = input;
					}}
					onChange={this.onChangeHandlerCPF}
					value={cpf}
				/>
			);
		}
	};

	showTitleWithEmail = (e) => {
		if (e === true) return <Title text="Informe o número do seu CPF, telefone e e-mail " />;

		return <Title text="Informe seus dados para continuar!" />;
	};

	render() {
		const { firstBlur } = this.state;
		const { value, valid, validEmail, validCPF, errorMessage, errorMessageCPF, errorMessageEmail } = this.props;
		var validEmailTmp = validEmail;
		var validCPFTmp = validCPF;
		if (this.props.envObj.displayEmail === false) validEmailTmp = true;
		if (this.props.envObj.displayCPF === false) validCPFTmp = true;

		//console.log(this.props.envObj);
		//console.log(validEmailTmp);

		return (
			<React.Fragment>
				{this.showTitleWithEmail(this.props.envObj.displayEmail)}

				<div className="ha-v">
					<PhoneInput
						ref={(input) => {
							this.phoneInput = input;
						}}
						onChange={this.onChangeHandler}
						onBlur={this.onBlurHandler}
						value={value}
					/>
					{!firstBlur && !valid && <div>{errorMessage}</div>}
				</div>
				<div className="ha-v">
					{this.fieldCPF(this.props.envObj.displayCPF)}
					{!firstBlur && !validCPF && <div>{errorMessageCPF}</div>}
				</div>

				<div className="ha-v">
					{this.fieldEmail(this.props.envObj.displayEmail)}
					{!firstBlur && !validEmail && <div>{errorMessageEmail}</div>}
				</div>

				<Button
					ref={(input) => {
						this.button = input;
					}}
					label="continuar"
					onClick={this.handleClick}
					disabled={!(valid && validEmailTmp && validCPFTmp)}
				/>

				<p className="ha-o-t">
					Ao entrar você concorda com os{" "}
					<a target="_blank" rel="noopener noreferrer" onClick={this.handleClickTerms}>
						Termos
					</a>{" "}
					e{" "}
					<a target="_blank" rel="noopener noreferrer" onClick={this.handleClickTerms}>
						Política de Privacidade
					</a>
					.
				</p>
			</React.Fragment>
		);
	}
}

export default InsertPhone;
